module.exports = __webpack_public_path__ + "img/screenshot-intro.27fa6f9f.png";